import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Back from "../../../../assets/img/BackArrow.png";
import InfoIcon from "../../../../assets/svg/InfoIcon.svg";
import ReusableTabs from "../../../../components/TabMenu/Tabs";
import { useAuthentication } from "../../../hooks/useAuthentication";
import { getApplicationsData } from "./API/fetchApplications";
import styles from "./OdobrenjeAplikacija.module.css";
import OdobrenjeTable from "./Table/OdobrenjeTable";
import {
  columnNames,
  countOccurrences,
  getAllowedApplicationProgramIds,
  odobrenjeAplikacijeTabs,
  programIdToKeyMap,
} from "./utils";

function OdobrenjeAplikacija() {
  const navigate = useNavigate();
  const { authToken } = useAuthentication();
  const [currentTabIndex, setCurrentTabIndex] = useState();
  const [applicationsData, setApplicationsData] = useState([]);
  const [userData, setUserData] = useState({});

  const handleTabChange = (event, newValue) => {
    setCurrentTabIndex(newValue);
    navigate(`/odobrenje-aplikacija/${newValue}`);
  };

  useEffect(() => {
    if (authToken) getApplicationsData(authToken, setApplicationsData);
  }, [authToken]);
  useEffect(() => {
    if (!currentTabIndex || applicationsData.length === 0) return;
    const selectedTabs = odobrenjeAplikacijeTabs.filter((tab) =>
      currentTabIndex.split(",").some((id) => tab.value.split(",").includes(id))
    );
    if (selectedTabs.length === 0) return;
    const validProgramIds = selectedTabs.flatMap((tab) => tab.value.split(","));
    const newMatchingTableData = applicationsData.filter((item) => {
      const validGroups = item.groups?.filter((group) => {
        if (!group.showProgramApplications) return false;
        const allowedProgramIds = getAllowedApplicationProgramIds(
          group.programId
        );
        const isValidProgram =
          allowedProgramIds.includes(String(item.programId)) &&
          validProgramIds.some((id) => allowedProgramIds.includes(id));
        return isValidProgram;
      });
      return validGroups?.length > 0;
    });
    const newUserArray = newMatchingTableData.map((item) => ({
      applicationId: item.id,
      userId: item.userId,
      firstName: item.User.firstName,
      lastName: item.User.lastName,
      imageUrl: item.User.imageUrl,
      mentorReview: item.mentorReview,
      isMentorAccepted: item.isMentorAccepted,
    }));
    setUserData(newUserArray);
  }, [applicationsData, currentTabIndex]);

  const tabOccurrences = {};
  const filteredApplications = applicationsData.filter((item) => {
    const validGroups = item.groups?.filter((group) => {
      if (!group.showProgramApplications) return false;
      const allowedProgramIds = getAllowedApplicationProgramIds(
        group.programId
      );
      return allowedProgramIds.includes(String(item.programId));
    });
    return validGroups?.length > 0;
  });
  const programIdList = filteredApplications.map((item) =>
    String(item.programId)
  );
  const desiredOrder = ["OR", "eOR", "TP1", "TP2", "TT"];

  const idOccurrences = countOccurrences(programIdList);
  const matchingTabs = odobrenjeAplikacijeTabs
    .filter((tab) =>
      tab.value.split(",").some((id) => programIdList.includes(id))
    )
    .sort((a, b) => {
      const getSortKey = (tab) => {
        const ids = tab.value.split(",");
        const key = ids.map((id) => programIdToKeyMap[id]).find(Boolean);
        return key ? desiredOrder.indexOf(key) : Number.MAX_SAFE_INTEGER;
      };
      return getSortKey(a) - getSortKey(b);
    });
  matchingTabs.forEach((tab) => {
    const ids = tab.value.split(",");
    const totalCount = ids.reduce(
      (sum, id) => sum + (idOccurrences[id] || 0),
      0
    );
    tabOccurrences[tab.value] = totalCount;
  });
  return (
    <div className={styles.wrapper}>
      <div
        className={styles.navigationRow}
        onClick={() => navigate("/dokumenti")}
      >
        <img alt="" src={Back} className={styles.backArrow} />
        <span style={{ fontSize: 20 }}>Natrag</span>
      </div>

      {matchingTabs.length > 0 ? (
        <ReusableTabs
          currentTabIndex={currentTabIndex}
          handleTabChange={handleTabChange}
          tabsData={matchingTabs}
          tabOccurrences={tabOccurrences}
          isTabOccurences
        />
      ) : (
        <div
          style={{
            display: "flex",
            gap: 10,
            backgroundColor: "#ffebeb",
            width: "100%",
            height: 40,
            borderRadius: 6,
            fontSize: 15,
            fontFamily: "Inter",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "500",
            color: "#5f6d7e",
          }}
        >
          <img alt="" src={InfoIcon} height={18} width={18} />
          Trenutno nemate aplikacija za pregled!
        </div>
      )}
      <div className={styles.tableWrapper}>
        {matchingTabs.map((tab) => (
          <React.Fragment key={tab.value}>
            {currentTabIndex === tab.value && (
              <OdobrenjeTable
                data={userData}
                columnNames={columnNames(tab.label)}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default OdobrenjeAplikacija;
